/*
 * @Description: Do not edit
 * @Author: Do not edit
 * @Date: 2019-10-27 16:30:07
 * @LastEditTime: 2019-11-08 17:22:48
 * @LastEditors: he.jianbo
 */
/**
 * 描述：辅助编辑中trs校对的指令
 * 日期：2017-9-29
 * 作者：Bai.Zhiming
 */
'use strict';
angular.module('scTrsCheckModule', []).directive('scTrsCheck', [
    '$stateParams',
    'heimaCheckService',
    'modalDialog',
    function($stateParams, heimaCheckService, modalDialog) {
        return {
            restrict: 'E',
            replace: 'true',
            transclude: 'false',
            scope: false,
            templateUrl: './editingCenter/directive/supportCreation/trsCheck/trsCheck_tpl.html',
            link: function(scope, $elem, $attrs) {
                initStatus();

                /**
                 * [getSiteId description] 获取当前编辑页的siteid
                 * @return {[type]} [description]
                 */
                function getSiteId() {
                    var siteid;
                    var flag = true;
                    for (var i in $stateParams) {
                        // 如果key中包含"siteid"，则使用该key匹配
                        if (i.indexOf('siteid') >= 0) {
                            siteid = $stateParams[i];
                            flag = false;
                            break;
                        }
                    }
                    if (flag) {
                        siteid = $stateParams.paperid; // 如果key中不包含siteid，则一定是报纸渠道，使用paperid
                    }
                    return siteid;
                }

                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    scope.data = {};
                    // heimaCheckService.isCheckHeimaWords(Number(scope.mediaType), scope.$parent.list.METADATAID, "", scope.$parent.list.TITLE, getSiteId(), $stateParams.wxchannelid).
                    proofreading();
                    scope.$on('$destroy', function() {
                        heimaCheckService.leaveCheckoutMode(scope);
                        // 取消错别字校对代码
                    });
                }

                /**
                 * [proofreading description] 校验函数
                 * @return  {[type]}  [return description]
                 */
                function proofreading() {
                    if (scope.isTrsCheckFromSave) {
                        return;
                    }
                    var ue = UE.getEditor('ueditor');
                    var htmlContent = ue.getContent();
                    htmlContent = clearMarkHeimaWord(htmlContent);
                    ue.setContent(htmlContent);
                    heimaCheckService.isCheckFuncunWords().then(
                        function() {
                            heimaCheckService.markHeimaWordCompare(scope);
                        },
                        function() {
                            modalDialog.alertType('校对系统异常！', '', 'warning', false);
                        }
                    );
                }
                
                /**
                 * [clearMarkHeimaWord description] 清除黑马标志
                 * @param {string} [htmlContent] [description] 正文
                 * @return {[type]} [description]
                 */
                function clearMarkHeimaWord(htmlContent) {
                    var dom = document.createElement('div');
                    dom.innerHTML = htmlContent;
                    $(dom)
                        .find('span.trasScale')
                        .each(function() {
                            $(this).replaceWith(this.innerHTML.replace(/\（.*\）/, ''));
                        });
                    return dom.innerHTML;
                }

                scope.proofreading = function() {
                    proofreading();
                };

                /**
                 * [replaceWord description] 替换错误词
                 * @param {index} item [description] 检索错误对象信息
                 * @param {index} index [description] 替换序号
                 * @param {index} type [description] 判断是替换还是或略操作
                 * @param {index} finish [description] 完成之后的回调函数
                 * @return {[type]} [description]
                 */
                scope.operating = function(item, index, type, finish) {
                    var words = type === 'replace' ? item.advise : item.error_word;
                    if (!!words) {
                        var ue = UE.getEditor('ueditor');
                        var htmlContent = ue.getContent();
                        var htmlDiv = document.createElement('div');
                        htmlDiv.innerHTML = htmlContent;
                        var errorWord = $(htmlDiv).find("span[index='" + index + "']");
                        $('<span>' + words + '</span>').insertAfter(errorWord);
                        errorWord.remove();
                        $(htmlDiv)
                            .find('span[trscheck]')
                            .each(function(index) {
                                $(this).attr('index', index);
                            });
                        htmlContent = htmlDiv.innerHTML;
                        ue.setContent(htmlContent);
                        scope.subHeimaWordsArr.splice(index, 1);
                    }
                    index--;
                    if (finish) {
                        finish(index);
                    }
                };

                /**
                 * [replaceWord description] 替换错误词
                 * @param {index} [varname] [description] 替换序号
                 * @return {[type]} [description]
                 */
                scope.ignoreWord = function(item, index, finish) {
                    if (!!item.error_word) {
                        var ue = UE.getEditor('ueditor');
                        var htmlContent = ue.getContent();
                        var htmlDiv = document.createElement('div');
                        htmlDiv.innerHTML = htmlContent;
                        var errorWord = $(htmlDiv).find("span[index='" + index + "']");
                        errorWord.after(item.error_word);
                        errorWord.remove();
                        $(htmlDiv)
                            .find('span[trscheck]')
                            .each(function(index) {
                                $(this).attr('index', index);
                            });
                        htmlContent = htmlDiv.innerHTML;  
                        ue.setContent(htmlContent);
                        scope.subHeimaWordsArr.splice(index, 1);
                    }
                    index--;
                    if (finish) {
                        finish(index);
                    }
                };

                /**
                 * [replaceAll description] 全部替换
                 * @return {[type]} [description]
                 */
                scope.replaceAll = function() {
                    var index = scope.subHeimaWordsArr.length - 1;
                    scope.replaceWord(scope.subHeimaWordsArr[index], index, success);

                    function success(index) {
                        if (index >= 0) {
                            scope.replaceWord(scope.subHeimaWordsArr[index], index, success);
                        }
                    }
                };
            },
        };
    },
]);
